/**
 * Lời gọi API quản trị đa tỉnh — MH-39 — đợt 3 phần C4. Khớp
 * `apps/api/src/da-tinh/da-tinh.controller.ts`.
 */
import { goi } from './goi-chung';
import { datToken } from './khach-api';

export interface DongTenant {
  id: string;
  maTinh: string;
  tenTinh: string;
  trangThai: string;
  congTacGuiDuLieu: boolean;
  hanMucThietBi: number | null;
  hanMucLuuTruGb: number | null;
  soThietBi: number;
  soNguoiDung: number;
  /** Số đơn vị hành chính đã nhập (hợp đồng A0 đa tỉnh mục 2) — vắng ở API cũ. */
  soDonViHanhChinh?: number;
  dungLuongDaDungByte: number;
  phanTramDungLuong: number | null;
}

/** Thân `POST /platform/tenants` (hợp đồng A0 đa tỉnh mục 2). */
export interface ThanTaoTinh {
  maTinh: string;
  tenTinh: string;
  emailCongVu?: string;
  quanTri: { tenDangNhap: string; hoTen: string; email?: string };
}

/** Kết quả tạo tỉnh: mật khẩu ban đầu trả MỘT LẦN, bắt buộc đổi khi đăng nhập lần đầu. */
export interface KetQuaTaoTinh {
  tenantId: string;
  maTinh: string;
  tenDangNhap: string;
  matKhauBanDau: string;
}

export const daTinhApi = {
  danhSach(signal?: AbortSignal): Promise<DongTenant[]> {
    return goi('/api/v1/platform/tenants', { signal });
  },
  taoTinh(than: ThanTaoTinh): Promise<KetQuaTaoTinh> {
    return goi('/api/v1/platform/tenants', { phuongThuc: 'POST', than });
  },
  datCongTacDongBo(id: string, bat: boolean): Promise<void> {
    return goi(`/api/v1/platform/tenants/${id}/dong-bo`, { phuongThuc: 'POST', than: { bat } });
  },
  /**
   * Chuyển ngữ cảnh sang một tỉnh: máy chủ cấp lại access token phạm vi tỉnh đó.
   * Ghi token mới vào localStorage NGAY để mọi lời gọi sau đó (kể cả điều hướng
   * sang /thiet-bi) đi theo đúng ngữ cảnh tỉnh vừa chọn.
   */
  async chuyenNguCanh(id: string): Promise<{ accessToken: string; tenTinh: string; maTinh: string }> {
    const kq = await goi<{
      accessToken: string;
      hoSo: { tenTinh: string; maTinh: string };
    }>(`/api/v1/platform/tenants/${id}/chuyen-ngu-canh`, { phuongThuc: 'POST' });
    datToken(kq.accessToken);
    return { accessToken: kq.accessToken, tenTinh: kq.hoSo.tenTinh, maTinh: kq.hoSo.maTinh };
  },
};
